import { useCallback } from 'react'
import { Popup } from 'components/Popup'
import { Button, BUTTON_TYPES } from 'components/Button'
import { Typography } from 'components/Typography'
import { BTN_TXT } from 'constants/txt'
import { useCRUDUserPopupProviderContext } from '../Provider/CRUDUserPopupProvider'

type ActivateWithoutCategoriesPopupProps = {
  userName: string
  onApproveCategories: (categories: string[]) => void
}

export const ActivateWithoutCategoriesPopup = ({
  userName,
  onApproveCategories
}: ActivateWithoutCategoriesPopupProps) => {
  const {
    activateWithoutCategoriesPopup: {
      actions: { close },
      state: { visible, title }
    },
    reviewAndApproveCategoriesPopup
  } = useCRUDUserPopupProviderContext()

  const onCancel = useCallback(() => {
    close()
    reviewAndApproveCategoriesPopup.actions.open()
  }, [close, reviewAndApproveCategoriesPopup.actions])

  const onActivate = useCallback(() => {
    onApproveCategories([])
  }, [onApproveCategories])

  return (
    <Popup
      visible={visible}
      onCancel={onCancel}
      title={title}
      width={442}
      footer={
        <>
          <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} onClick={onActivate} upperCase>
            {BTN_TXT.ACTIVATE_USER}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        All categories will be declined and {userName} will be activated with no
        assigned categories. All categories can be managed from {userName}'s
        profile.
      </Typography.Body1>
    </Popup>
  )
}
